"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControlGroupStates = exports.classes = void 0;
var base = "luna-form_control_group";
var labelBase = "".concat(base, "--label");
var classes = {
  wrapper: {
    base: base,
    isDisabled: "".concat(base, "-is_disabled"),
    isInvalid: "".concat(base, "-is_invalid"),
    isOmitted: "".concat(base, "-is_omitted"),
    isAssumed: "".concat(base, "-is_assumption")
  },
  label: {
    base: labelBase,
    message: "".concat(labelBase, "_message"),
    optionality: "".concat(labelBase, "_optionality"),
    utility: "".concat(labelBase, "_utility")
  },
  input: {
    base: "".concat(base, "--input_group")
  },
  context: {
    wrapper: "".concat(base, "--context"),
    helpMessage: "".concat(base, "--help_message"),
    systemMessage: "".concat(base, "--system_message")
  }
};
exports.classes = classes;
var FormControlGroupStates = {
  omitted: 'omitted',
  assumed: 'assumed'
};
exports.FormControlGroupStates = FormControlGroupStates;
